import { Response } from 'shared/models/general.ts'

import {
  CitizenshipAvia,
  CitizenshipBeket,
  CitizenshipTour,
} from './CitizenshipModel'
import { clientApi } from './clientApi'

export const CitizenshipsApi = {
  getCitizenships() {
    return clientApi.get<Response<CitizenshipAvia[]>>(
      '/flights/citizenships?api_version=v2',
    )
  },
  getCitizenshipBeket() {
    return clientApi.get<Response<CitizenshipBeket[]>>('/bus/countries')
  },
  getCitizenshipTour() {
    return clientApi.get<Response<CitizenshipTour[]>>(
      `/tours/andromeda/citizenships`,
    )
  },
}
